export interface FloatingButtonUser {
  id?: number;
  email?: string | null;
  fullName?: string;
  staffType?: string;
  staffProject?: string;
  businessUnit?: string;
}
